import axios from './index.js'
import store from '@/store'
function cleanParams (params) {
  return Object.fromEntries(Object.entries(params).filter(arr => arr[1] || arr[1] === 0))
}
// 任务类型
export const getTaskType = () => {
  return axios.get('/welldbCombine/taskType', {
    params: {
      pageNum: 1,
      pageSize: 10000
    }
  })
}
// 创建任务
export const createTask = (params) => {
  const user = store.state.userInfo
  return axios.post('/welldbCombine/task', {
    moveToQuery: true,
    params: cleanParams({ ...params, createUserId: user.userId })
  })
}
// 修改
export const updateTask = (params) => {
  return axios.put('/welldbCombine/task', {
    moveToQuery: true,
    params: cleanParams(params)
  })
}
export const deleteTask = (id) => {
  return axios.delete('/welldbCombine/task', {
    params: {
      id
    }
  })
}
// 我是标注客户，获取我的发布任务
export const getMyRelease = (params) => {
  return axios.get('/welldbCombine/task', {
    params: cleanParams(params)
  })
}
// 拆分任务
export const getSplitTask = (params) => {
  return axios.get('/welldbCombine/task/split', {
    params: cleanParams(params)
  })
}
// 重置任务
export const getResetTask = (params) => {
  return axios.get('/welldbCombine/task/reset', {
    params: cleanParams(params)
  })
}
// 我是团队管理员，获取我的待接收任务(可接收、拒绝)
export const getMyReception = (params) => {
  return axios.get('/labourAssignRecord/get', {
    params: {
      excuteUserId: store.state.userInfo.id,
      currentPage: params.currentPage || 1,
      pageSize: params.pageSize || 10
    }
  }).then(res => {
    if (res.data.errorCode - 0 === 0) {
      return res.data.map.pageBean
    }
  })
}

// 我是团队管理员，获取我的分配任务
// 这里的任务是已接收的，状态流转为：待拆分、已拆分待分配标注、已分配标注中、已标注待分配审核、已审核等
export const getMyAllocation = () => {}

// 我是干活的，获取我的标注任务
export const getMyLabelTask = (params) => {
  return axios.get('/labourAssignRecord/get', {
    params: {
      excuteUserId: store.state.userInfo.id,
      state: 'origin',
      currentPage: params.currentPage || 1,
      pageSize: params.pageSize || 10
    }
  }).then(res => {
    if (res.data.errorCode - 0 === 0) {
      return res.data.map.pageBean
    }
  })
}

// 我是干活的，获取我的修改任务
export const getMyModifyTask = (params) => {
  return axios.get('/labourAssignRecord/get', {
    params: {
      excuteUserId: store.state.userInfo.id,
      state: 'modify',
      currentPage: params.currentPage || 1,
      pageSize: params.pageSize || 10
    }
  }).then(res => {
    if (res.data.errorCode - 0 === 0) {
      return res.data.map.pageBean
    }
  })
}

// 我是干活的，获取我的审核任务
export const getMyAuditTask = (params) => {
  return axios.get('/labourAssignRecord/get', {
    params: {
      excuteUserId: store.state.userInfo.id,
      state: 'check',
      currentPage: params.currentPage || 1,
      pageSize: params.pageSize || 10
    }
  }).then(res => {
    if (res.data.errorCode - 0 === 0) {
      return res.data.map.pageBean
    }
  })
}
